<template>
    <select :name="props.name" :class="props.classSelect" @change="onChange" ref="select">
        <option value="" v-if="caption">{{ props.caption }}</option>
        <option v-for="option in props.options" :value="option.id">{{ option.name }}</option>
    </select>
</template>

<script setup lang="ts">

const select = ref<HTMLSelectElement>(null);
const props = defineProps({
    caption: {
        type: String,
        default: ''
    },
    options: {
        type: Array,
        required: true,
    },
    name: {
        type: String,
        default: ''
    },
    classSelect: {
        type: String,
        default: 'select'
    }
});

const emits = defineEmits(['change']);

function onChange() {
    const value = +select.value.value;
    emits('change', props.options.find(el => el.id === value));
}
</script>